import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <p className="footer-text">
            © 2025 <span className="footer-brand">NHO</span> – A <span className="footer-company">Nai Vàng</span> Product.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

